import type { IconData } from '@stacksjs/iconify-core'

export const jm4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#000001\" d=\"m0 0l320 240L0 480zm640 0L320 240l320 240z\"/><path fill=\"#090\" d=\"m0 0l320 240L640 0zm0 480l320-240l320 240z\"/><path fill=\"#fc0\" d=\"M640 0h-59.6L0 435.3V480h59.6L640 44.7z\"/><path fill=\"#fc0\" d=\"M0 0v44.7L580.4 480H640v-44.7L59.6 0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default jm4x3
